import { render, staticRenderFns } from "./BeneficiaryRelationship.vue?vue&type=template&id=6e432896"
import script from "./BeneficiaryRelationship.vue?vue&type=script&lang=js"
export * from "./BeneficiaryRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports